<template>
    <div class="property-nearby" :class="theme">

        <section>
            <div class="grid xs-grid-cols-1" :comp="theme === 'newDpp' && 'newInZipCode'">
                <h3 class="flex" v-if="theme === 'newDpp'">
                    <a :href="getMSPLink('new-7')" class="link" v-ga:click>
                        <b class="f4 text-bold">{{molang('dpp.newIn',{zip:dpp.geo.zipcode})}}</b>
                    </a>
                </h3>
                <h3 class="f4 text-bold" v-else>
                    <a class="link" :href="getMSPLink('new-7')">
                        {{molang('dpp.newIn',{zip:dpp.geo.zipcode})}}
                    </a>
                </h3>
                <mvtLazyload ref="lazyloadNew" data-role="propertycard">
                  <mvtNearby type="zipcode" filterPath="/new-7/" :filterId="dpp.propertyId" @completed="completedNew" carousalType="new"></mvtNearby>
                </mvtLazyload>
            </div>
        </section>
        <section>
            <div class="grid xs-grid-cols-1" :comp="theme === 'newDpp' && 'priceReduced'">
                <h3 class="flex" v-if="theme === 'newDpp'">
                    <a :href="getMSPLink('reduced-30')" class="link" v-ga:click>
                        <b class="f4 text-bold">{{molang('dpp.newDppPriceReducedIn',{zip:dpp.geo.zipcode})}}</b>
                    </a>
                </h3>
                <h3 class="f4 text-bold" v-else>
                    <a class="link" :href="getMSPLink('reduced-30')">
                        {{molang('dpp.priceReducedIn',{zip:dpp.geo.zipcode})}}
                    </a>
                </h3>
                <mvtLazyload ref="lazyloadPrice" data-role="propertycard">
                  <mvtNearby cardFilter="priceCut" type="zipcode" filterPath="/reduced-30/" :filterId="dpp.propertyId" @completed="completedPrice" carousalType="reduced"></mvtNearby>
                </mvtLazyload>
            </div>
        </section>
        <section>
            <div class="grid xs-grid-cols-1" :comp="theme === 'newDpp' && 'openHouses'">
                <h3 class="flex" v-if="theme === 'newDpp'">
                    <a :href="getMSPLink('open-houses')" class="link" v-ga:click>
                        <b class="f4 text-bold">{{molang('dpp.openIn',{zip:dpp.geo.zipcode})}}</b>
                    </a>
                </h3>
                <h3 class="f4 text-bold" v-else>
                    <a class="link" :href="getMSPLink('open-houses')">
                        {{molang('dpp.openIn',{zip:dpp.geo.zipcode})}}
                    </a>
                </h3>
                <mvtLazyload ref="lazyloadOpen" data-role="propertycard">
                  <mvtNearby cardFilter="openHouse" type="zipcode" filterPath="/open-houses/" :filterId="dpp.propertyId" @completed="completedOpen" carousalType="open_house"></mvtNearby>
                </mvtLazyload>
            </div>
        </section>
    </div>
</template>
<script src="./property-nearbyzipcode.js"></script>

<style lang="scss">
@use './property-nearbyzipcode.scss' as *;
</style>
